import "./App.css";
import UserRouting from "./Routing/UserRouting";
import { BrandingProvider } from "./Context/BrandingContext";

function App() {
  return (
    <div className="App">
      <BrandingProvider>
        <UserRouting />
      </BrandingProvider>
    </div>
  );
}

export default App;
